// extracted by mini-css-extract-plugin
module.exports = {"heading":"locale-nav_heading__2EPuz","link":"locale-nav_link__3Zmcq","element":"locale-nav_element__nNswc","list":"locale-nav_list__3k1CH"};